import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-tags",
  "use": "svg_menu-tags-usage",
  "viewBox": "0 0 13 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 9\" id=\"svg_menu-tags\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 2h6l2.662 2.5L8 7H2V2ZM0 1a1 1 0 0 1 1-1h7.55a1 1 0 0 1 .748.336l3.111 3.5a1 1 0 0 1 0 1.328l-3.11 3.5A1 1 0 0 1 8.55 9H1a1 1 0 0 1-1-1V1Zm8 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z\" fill=\"#99CC57\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol